<template>
  <section class="table-sampler-result-noise">
    <d-form-row class="mb-1">
      <d-col cols="3">
        <label>Metabolismo médio ponderado</label>
        <input
          type="text"
          class="form-control"
          placeholder="Metabolismo"
          v-model="model.metabolism"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>IBUTG Médio ponderado</label>
        <input
          type="text"
          class="form-control"
          placeholder="IBUTG médio"
          v-model="model.ibtug"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>IBUTG Nível de ação</label>
        <input
          type="text"
          class="form-control"
          placeholder="Nível de ação"
          v-model="model.action_level"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>IBUTG Max.</label>
        <input
          type="text"
          class="form-control"
          placeholder="IBUTG Max."
          v-model="model.max"
          required
        />
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { NOISE_RESULT, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Noise',
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_RESULT),
    };
  },
  methods: {
    setModel() {
      if (this.result) {
        this.model = this.result;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:result', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
